/* eslint-disable react/prefer-stateless-function */
// Copyright (c) 2022 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import Implements from '@deere/cps-it.warranty-model-factory/lib/implements';

class BaseMachineComponentBody extends Component {

    render() {

        return (
            <section className={'base-machine-component-body'}>
                <div>

                    <input
                        className='base-component'
                        onChange={this.props.onComponentChange}
                        type='text'
                        value={this.props.component.serialNumber}
                    />
                </div>

                <span className='delete-icon-button'>
                    <button
                        className='icon-trash-can'
                        onClick={this.props.onDelete}
                    />
                </span>
            </section>

        );

    }
}
BaseMachineComponentBody.displayName = 'BaseMachineComponentBody';
BaseMachineComponentBody.propTypes = {
    component: PropTypes.instanceOf(Implements).isRequired,
    onComponentChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default BaseMachineComponentBody;



// WEBPACK FOOTER //
// ./src/product/details/components/base-machine-component-body.js